import * as React from "react";
import { observer } from "mobx-react";

import { UitkLayoutGrid, UitkLayoutGridItem } from "uitk-react-layout-grid";
import { UitkExpandoLink, UitkExpandoLinkTypeSize } from "uitk-react-expando";
import { UitkSpacing } from "uitk-react-spacing";

import { useLocalization } from "@shared-ui/localization-context";

import { VendorCodesProps } from "components/flexComponents/WizardCarPWA/typings";
import { BrandDropdown } from "./BrandDropdown";
import { CouponCodeDropdown } from "./CouponCodeDropdown";
import { CouponCodeEntryFields } from "./CouponCodeEntryFields";
import { locKeys } from "../l10n";
import { CarTypeDropdown } from "./CarTypeDropdown";
import { CarType, CarVendorName, CarDiscountType } from "./CarUtils";

export const VendorCodes = observer(({ carWizardState, mainColSpan, colSpan }: VendorCodesProps) => {
  const { formatText } = useLocalization();
  const {
    isBiasedWizardEmpty,
    carVendorName,
    carType,
    showCarDiscount,
    disableVendorCouponCode,
    iHaveDiscount,
  } = carWizardState.config;

  return (
    <UitkSpacing margin={{ blockstart: "three" }}>
      <UitkExpandoLink
        type={UitkExpandoLinkTypeSize.TYPE_300}
        expandoTitle={formatText(iHaveDiscount)}
        isVisible={carVendorName || carType}
      >
        <UitkSpacing margin={{ blockstart: "three" }}>
          <UitkLayoutGrid columns={mainColSpan} space="three">
            {!isBiasedWizardEmpty && !carType && <CarTypeDropdown carWizardState={carWizardState} colSpan={colSpan} />}
            {!isBiasedWizardEmpty && carType && (
              <UitkLayoutGridItem colSpan={colSpan}>{CarType(carWizardState)}</UitkLayoutGridItem>
            )}

            {!carVendorName && (
              <BrandDropdown
                label={formatText(locKeys.brandSelectionLabel)}
                lobState={carWizardState}
                colSpan={colSpan}
              />
            )}
            {carVendorName && (
              <UitkLayoutGridItem colSpan={colSpan}>{CarVendorName(carWizardState)}</UitkLayoutGridItem>
            )}

            {!disableVendorCouponCode && !showCarDiscount && (
              <CouponCodeDropdown
                label={formatText(locKeys.couponCodeSelectionLabel)}
                carWizardState={carWizardState}
                colSpan={colSpan}
              />
            )}
            {!disableVendorCouponCode && showCarDiscount && (
              <UitkLayoutGridItem colSpan={colSpan}>{CarDiscountType(carWizardState)}</UitkLayoutGridItem>
            )}

            <CouponCodeEntryFields
              carWizardState={carWizardState}
              vendor={carWizardState.preferredBrand}
              colSpan={colSpan}
            />
          </UitkLayoutGrid>
        </UitkSpacing>
      </UitkExpandoLink>
    </UitkSpacing>
  );
});
